import { IVitalSyncRepository } from "../../adapters/driven/repositories/vitalSyncRepository";

export const VitalSyncServiceImplFactory = ({
  vitalSyncRepository,
}: {
  vitalSyncRepository: IVitalSyncRepository;
}) => {
  const extractVitals: IExtractVitalsService = async (payload) => {
    try {
      const response = await vitalSyncRepository.ExtractVitalsAPI(payload);

      // Check for 401 Unauthorized (session expired)
      // When API returns 401, the response is the error data object
      const responseAny = response as any;
      if (
        responseAny?.statusCode === 401 ||
        responseAny?.message?.toLowerCase().includes("unauthorized")
      ) {
        console.warn(
          "[VitalSync] Session expired during vitals extraction - refreshing page"
        );
        window.location.reload();
        return {
          success: false,
          error: { message: "Session expired. Refreshing page..." },
        };
      }

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const submitVitalsToPCC: ISubmitVitalsToPCCService = async (payload) => {
    try {
      const response = await vitalSyncRepository.SubmitVitalsToPCCAPI(payload);

      // Check for 401 Unauthorized (session expired)
      // When API returns 401, the response is the error data object
      const responseAny = response as any;
      if (
        responseAny?.statusCode === 401 ||
        responseAny?.message?.toLowerCase().includes("unauthorized")
      ) {
        console.warn(
          "[VitalSync] Session expired during PCC submission - refreshing page"
        );
        window.location.reload();
        return {
          success: false,
          error: { message: "Session expired. Refreshing page..." },
        };
      }

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const getPCCSubmissionStatistics: IGetPCCSubmissionStatisticsService = async (
    payload
  ) => {
    try {
      const response = await vitalSyncRepository.GetPCCSubmissionStatisticsAPI(
        payload
      );
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const getPCCQueueList: IGetPCCQueueListService = async (payload) => {
    try {
      const response = await vitalSyncRepository.GetPCCQueueListAPI(payload);
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  return {
    extractVitals,
    submitVitalsToPCC,
    getPCCSubmissionStatistics,
    getPCCQueueList,
  };
};
